import dayjs from "dayjs"
import "dayjs/locale/zh-cn"

function timestampToTimeString(timestamp: number) {
  if (timestamp === 0) return ""
  const result = dayjs(timestamp).format("YYYY-MM-DD HH:mm:ss")

  return result
}

function getDayName(timestamp: number) {
  return dayjs(timestamp).format("YYYY-MM-DD")
}

function formatToMin(timestamp: number) {
  return dayjs(timestamp).format("YYYY-MM-DD HH:mm")
}

function formatToDaytime(timestamp: number) {
  return dayjs(timestamp).format("HH:mm:ss")
}

function formatTime(timestamp: number, formatString: string) {
  return dayjs(timestamp).format(formatString)
}

function getDayNameList(start: number, days: number) {
  let timestamp = start
  const result: string[] = []
  for (let i = 0; i < days; i++) {
    result.push(getDayName(timestamp))
    timestamp += 86400000
  }
  return result
}

function getTodayStart(dayOffset: number = 0) {
  return dayjs().add(dayOffset, "day").startOf("d").toDate().getTime()
}

function getDayStart(timestamp: number) {
  return dayjs(timestamp).startOf("d").toDate().getTime()
}

export const timeUtils = {
  getDayName,
  getDayNameList,
  getTodayStart,
  getDayStart,
  timestampToTimeString,
  formatToMin,
  formatTime,
  formatToDaytime,
  dayLength: 86400 * 1000,
} as const
